import { LOCALES_MAP } from '@config/constants';
import enUS from './en-us.json';
import deDe from './de-de.json';

const localizations = {
  [LOCALES_MAP.enUS]: enUS,
  [LOCALES_MAP.deDE]: deDe,
};

export default localizations;
